import React, {Component} from "react";

class WinnersAssets extends Component {
    render() {
        return (
            <>
                <div className="manRight">
                    <img src="scrap/images/DIAMANT_LP_wiosna-KONKURS_pop22_11.png" alt=""/>
                </div>
            </>
        )
    }
}

export default WinnersAssets;